var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_12111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13332 9.05841C9.04999 9.05008 8.94999 9.05008 8.85832 9.05841C6.87499 8.99175 5.29999 7.36675 5.29999 5.36675C5.29999 3.32508 6.94999 1.66675 8.99999 1.66675C11.0417 1.66675 12.7 3.32508 12.7 5.36675C12.6917 7.36675 11.1167 8.99175 9.13332 9.05841Z",
    stroke: "#1B1D52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96666 12.1333C2.95 13.4833 2.95 15.6833 4.96666 17.0249C7.25833 18.5583 11.0167 18.5583 13.3083 17.0249C15.325 15.6749 15.325 13.4749 13.3083 12.1333C11.025 10.6083 7.26666 10.6083 4.96666 12.1333Z",
    stroke: "#1B1D52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_12111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.1d4095587007be3abcdb2d7fbe7e6d1d.svg";
export { ForwardRef as ReactComponent };